import type { ReactNode } from 'react'
import './BlissFunnelFrame.css'

/** The original Public Quote Builder's cream-and-gold contact gate. */
export default function BlissFunnelFrame({ children }: { children: ReactNode }) {
  return (
    <main className="bliss-funnel-frame">
      <section className="bliss-funnel-card" aria-label="Bliss Bunk Beds">
        <header className="bliss-funnel-brand">
          <img src="/bliss-bedrooms-logo-transparent.png" alt="Bliss Bedrooms" width="180" height="117" style={{objectFit: "contain"}} />
        </header>
        <div className="bliss-funnel-content">{children}</div>
        <footer>
          Looking for something else?{' '}
          <a href="/track">Track Your Order</a>
        </footer>
      </section>
    </main>
  )
}
